import { DefaultExcludedServiceTags } from '../utils/CurrentSelectionType';

export function IsIncludeService(serviceTags: string[]) {
  return !serviceTags?.find((x) => DefaultExcludedServiceTags.includes(x));
}
